{
  "app": {
    "name": "VISION360"
  },
  "a11y": {
    "skipToContent": "Aller au contenu principal"
  },
  "loading": {
    "session": "Vérification de la session…",
    "page": "Chargement…"
  },
  "errors": {
    "network": "Impossible de joindre le serveur. Vérifiez votre connexion.",
    "generic": "Une erreur inattendue est survenue.",
    "retry": "Réessayer"
  },
  "footer": {
    "version": "Version {{version}}",
    "versionLoading": "Version…",
    "versionUnknown": "Version inconnue"
  },
  "notFound": {
    "title": "Page introuvable",
    "description": "Cette page n’existe pas ou a été déplacée.",
    "back": "Retour à l’accueil"
  }
}
